import { render, staticRenderFns } from "./SrDesignForm.vue?vue&type=template&id=04764402&"
import script from "./SrDesignForm.vue?vue&type=script&lang=js&"
export * from "./SrDesignForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports